import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Link } from 'wouter'
import { rehypeAutolink } from './markdownAutolink'
import { findTerm } from '../lore/glossary'

/** Renders a lore markdown string. Known entity names (bodies, factions,
 *  species, plants, named figures) are auto-linked to their entries, with a
 *  small tagline bubble on hover. Styled by the `.md` class in globals.css.
 *
 *  Pass `plain` to skip auto-linking and render links as plain anchors: useful
 *  for full-document reads (e.g. the export preview) where dotted links on every
 *  entity name would be noisy. */
export function Markdown({ children, plain = false }: { children: string; plain?: boolean }) {
  if (plain) {
    return (
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {children}
      </ReactMarkdown>
    )
  }
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeAutolink]}
      components={{
        a: ({ href = '', children }: any) => {
          const internal = href.startsWith('/')
          if (internal) {
            const text = Array.isArray(children)
              ? children.join('')
              : typeof children === 'string'
                ? children
                : ''
            const tip = text ? findTerm(text)?.tip : undefined
            return (
              <Link href={href} className="lore-link" data-tip={tip}>
                {children}
              </Link>
            )
          }
          return (
            <a href={href} target="_blank" rel="noreferrer">
              {children}
            </a>
          )
        },
      }}
    >
      {children}
    </ReactMarkdown>
  )
}
